/**
 * LogoutPage — J-5. 로그아웃 확인
 *
 * 서브메뉴에서 "로그아웃" 클릭 시 이 페이지로 진입.
 * 확인 팝업(Modal) 형태로 표시. 취소 시 이전 화면으로 복귀.
 */
import { useNavigate } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Modal } from '@indipia/ui-core';
import { useAuthStore, useAppStore, apiClient } from '@indipia/shared';

export function LogoutPage() {
  const navigate    = useNavigate();
  const queryClient = useQueryClient();
  const logout      = useAuthStore((s) => s.logout);
  const resetApp    = useAppStore((s) => s.reset);

  const mutation = useMutation({
    mutationFn: async () => {
      try {
        await apiClient.post('/gatepass/logout');
      } finally {
        logout();
        resetApp();
        queryClient.clear(); // studioStage 등 이전 유저 캐시 제거
      }
    },
    onSuccess: () => {
      navigate('/login', { replace: true });
    },
    onError: () => {
      navigate('/login', { replace: true });
    },
  });

  return (
    <Modal open title="로그아웃" onClose={() => navigate(-1)}>
      <p className="mb-5 text-sm text-text-muted">로그아웃 하시겠습니까?</p>

      <div className="flex gap-2">
        <Button
          variant="secondary"
          onClick={() => navigate(-1)}
          className="flex-1"
          disabled={mutation.isPending}
        >
          취소
        </Button>
        <Button
          variant="primary"
          onClick={() => mutation.mutate()}
          disabled={mutation.isPending}
          loading={mutation.isPending}
          className="flex-1"
        >
          확인
        </Button>
      </div>
    </Modal>
  );
}
